import type { LearnerType } from '@/types'

export type OutfitType = 'none' | 'detective' | 'warrior' | 'mage' | 'builder' | 'bard'

export interface OutfitConfig {
  id: Exclude<OutfitType, 'none'>
  name: string
  learnerType: LearnerType
  path: string
  description: string
  color: string
  price: number
  emoji: string
}

export const outfitConfigs: OutfitConfig[] = [
  { id: 'detective', name: '侦探套装', learnerType: 'story', path: '侦探之路', description: '用线索和故事拆解每一个英语问题。', color: '#a8744c', price: 25, emoji: '🔎' },
  { id: 'warrior', name: '勇士铠甲', learnerType: 'challenge', path: '勇士之路', description: '在挑战中稳步升级，突破下一层。', color: '#71808f', price: 25, emoji: '🛡️' },
  { id: 'mage', name: '魔法长袍', learnerType: 'game', path: '魔法之路', description: '把词汇、句型和表达变成语言魔法。', color: '#6852ad', price: 25, emoji: '🔮' },
  { id: 'builder', name: '建造工装', learnerType: 'task', path: '建造之路', description: '一砖一瓦完成任务，搭建自己的英语大厦。', color: '#d79d2a', price: 25, emoji: '🧰' },
  { id: 'bard', name: '吟游诗装', learnerType: 'social', path: '吟游之路', description: '在对话和分享中练习真实表达。', color: '#5f8f5b', price: 25, emoji: '🎵' },
]

export function getStarterOutfit(learnerType: LearnerType | null): OutfitType {
  return outfitConfigs.find((outfit) => outfit.learnerType === learnerType)?.id ?? 'none'
}

export function getOutfitConfig(id: OutfitType) {
  return outfitConfigs.find((outfit) => outfit.id === id)
}
